"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CfgCountryListEn = /** @class */ (function () {
    function CfgCountryListEn() {
    }
    CfgCountryListEn.getLangData = function () {
        return {
            document_title: "Countries",
            editor: {
                breadcrumb: {
                    new_country: ["Create country"],
                    edit_country: ["Edit country"]
                },
                message: {
                    country_added: "Country was added!",
                    country_changed: "Country was changed!"
                },
                error: {
                    field_title_empty: "Field [title] is empty!",
                    field_code_empty: "Field [code] is empty!",
                },
                title: {
                    new_country: "Add country",
                    edit_country: "Edit country",
                },
                fields: {
                    title: {
                        caption: "Title:",
                        placeholder: "Enter title",
                    },
                    code: {
                        caption: "Code:",
                        placeholder: "Enter code",
                    }
                },
                checkboxes: {
                    deprecated: "Country is deprecated",
                    unknown: "Country is unknown",
                },
                buttons: {
                    save: "Save",
                    create: "Create",
                    back: "Back",
                }
            }, list: {
                message: {
                    set_as_actual_fmt: "Country {0} marked as actual",
                    set_as_deprecated_fmt: "Country {0} marked as deprecated",
                    country_deleted_fmt: "Country {0} deleted succesfully",
                    all_country_deprecated: "All countries marked as deprecated",
                    all_country_actual: "All countries marked as actual"
                },
                rows: {
                    title: "Title",
                    code: "Code",
                    date_added: "Added",
                    deprecated: {
                        title: "Actual",
                        menu: {
                            actual: {
                                menu: "Set as actual",
                                text: "Yes"
                            },
                            deprecate: {
                                menu: "Set as deprecated",
                                text: "No"
                            }
                        },
                        filter: {
                            actual: "Actual",
                            deprecate: "Deprecated",
                        }
                    },
                    unknown: {
                        title: "Unknown",
                        filter: {
                            unknown: "Unknown",
                            known: "Known",
                        },
                        render: {
                            yes: "Yes",
                            no: "No"
                        }
                    },
                    action: {
                        title: "Actions",
                        edit: "Edit",
                        delete: {
                            hint: "Delete",
                            confirm: "Delete this record ?",
                        }
                    }
                },
                toolbars: {
                    hints: {
                        create: "Create",
                        refresh: "Update",
                    },
                    lock_all: {
                        confirm_title: "Set as deprecated ?",
                        ok_text: "Yes",
                        cancel_text: "No",
                        button_hint: "Set as deprecated"
                    },
                    unlock_all: {
                        confirm_title: "Set as actual ?",
                        ok_text: "Yes",
                        cancel_text: "No",
                        button_hint: "Set as actual"
                    }
                },
                footer: {
                    title_fmt: "Shown on page : {0} of {1} records",
                },
                details: {
                    created: "Created:",
                    changed: "Changed:",
                }
            }
        };
    };
    return CfgCountryListEn;
}());
exports.CfgCountryListEn = CfgCountryListEn;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_country/ui/lang/CfgCountryListEn.ts
// module id = 2055
// module chunks = 0